import { z } from 'zod';

import { LoginMaintenanceCriteriaVersion } from 'backend-client-web';

import { makeProtobufEnumSchema } from '../enumSchemas';
import objectPassthrough from '../objectPassthrough';
import { WithUnknownValuePlaceholder } from '../unknownValuePlaceholder';

interface PersistableLoginMaintenanceCriteria {
  version: WithUnknownValuePlaceholder<LoginMaintenanceCriteriaVersion>;
  // If this is set the vault is empty, no login maintenance rechecks need to be performed
  noLogin?: boolean;
  // undefined indicates that there's a login without a leak check
  leakedPasswordsMinChangeTime?: Date;
  // undefined indicates that there's a login without a login summary
  loginSummaryMinVersion?: number;
  // undefined indicates that there's a login without a password policy check
  passwordPolicyMinChangeTime?: Date;
}

const PersistableLoginMaintenanceCriteria = objectPassthrough({
  version: makeProtobufEnumSchema(
    LoginMaintenanceCriteriaVersion,
    LoginMaintenanceCriteriaVersion.UNKNOWN,
  ),
  noLogin: z.boolean().optional(),
  leakedPasswordsMinChangeTime: z.date().optional(),
  loginSummaryMinVersion: z.number().int().optional(),
  passwordPolicyMinChangeTime: z.date().optional(),
});

export { PersistableLoginMaintenanceCriteria };
